<template>
  <div>
    <v-simple-table dense style="width:100%;text-align:center;">
      <template v-slot:default style="text-align:center;">
        <thead>
          <tr>
            <th colspan="4" style="text-align:center;">
              Mensajeria
            </th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th style="text-align:center;">
              Kilos
            </th>
            <th style="text-align:center;">
              Primary
            </th>
            <th style="text-align:center;">
              Economy
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>0.5</div>
            </td>
            <td>
              <v-text-field
                @input="actualizarObjetoTarifa()"
                @focus="$event.target.select()"
                outlined
                dense
                v-model="copiaTarifasMensajeria.Primary"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                @input="actualizarObjetoTarifa()"
                @focus="$event.target.select()"
                outlined
                dense
                v-model="copiaTarifasMensajeria.Economy"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table dense style="width:100%;text-align:center;">
      <template v-slot:default style="text-align:center;">
        <thead>
          <tr>
            <th colspan="4" style="text-align:center;">
              Paqueteria
            </th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th style="text-align:center;">
              Kilos
            </th>
            <th style="text-align:center;">
              Primary
            </th>
            <th style="text-align:center;">
              Economy
            </th>
            <th style="text-align:center;">
              MEDAL
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in copiaTarifasPaqueteria.Primary" :key="index">
            <td>
              <div v-if="index == 0">0.5</div>
              <div v-else>{{ index }}</div>
            </td>
            <td>
              <v-text-field
                @input="actualizarObjetoTarifa()"
                @focus="$event.target.select()"
                outlined
                dense
                v-model="copiaTarifasPaqueteria.Primary[index]"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                @input="actualizarObjetoTarifa()"
                @focus="$event.target.select()"
                outlined
                dense
                v-model="copiaTarifasPaqueteria.Economy[index]"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                @input="actualizarObjetoTarifa()"
                v-if="copiaTarifasPaqueteria.MEDAL[index]"
                @focus="$event.target.select()"
                outlined
                dense
                v-model="copiaTarifasPaqueteria.MEDAL[index]"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- <v-btn @click="aceptar()">aceptar</v-btn> -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      copiaTarifasPaqueteria: {},
      copiaTarifasMensajeria: {}
    };
  },
  mounted() {
    console.log(this.Tarifas);
    this.copiaTarifasPaqueteria = JSON.parse(JSON.stringify(this.Tarifas.Paqueteria));
    this.copiaTarifasMensajeria = JSON.parse(JSON.stringify(this.Tarifas.Mensajeria));
    this.copiaTarifasServiciosAdicionales = JSON.parse(JSON.stringify(this.Tarifas.Servicios_adicionales));
  },
  props: {
    Tarifas: Object
  },
  methods: {
    ...mapActions("tarifas", ["insertDescuentos", "editTarifas"]),
    async actualizarObjetoTarifa() {
      let objetoTarifa = {
        // Id: 2,
        // Descripcion: "23",
        // Tarifa: {
        Mensajeria: this.copiaTarifasMensajeria,
        Paqueteria: this.copiaTarifasPaqueteria,
        Servicios_adicionales:this.copiaTarifasServiciosAdicionales
        // }
      };
      this.$emit("pasarTarifaHaciaModal", objetoTarifa);
      //   console.log({
      //     Mensajeria: this.copiaTarifasMensajeria,
      //     Paqueteria: this.copiaTarifasPaqueteria
      //   });
      //   const res = await this.editTarifas(sacuacole);
      //   if (res[0]) {
      //     this.$emit("muestraDialogExito", "Tarifa editada con éxito");
      //   } else {
      //     this.$emit("muestraModalErrorEnAccion", res[1]);
      //   }
    }
  }
};
</script>
